// JsFromRoutes CacheKey 038723855c0a3a950803eae85ed766f4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/signup'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/signup'),
  create: /* #__PURE__ */ definePathHelper('post', '/signup'),
  changeEmail: /* #__PURE__ */ definePathHelper('put', '/account/email'),
  changePassword: /* #__PURE__ */ definePathHelper('put', '/account/password'),
  edit: /* #__PURE__ */ definePathHelper('get', '/account'),
  update: /* #__PURE__ */ definePathHelper('patch', '/account'),
}
